/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  buyCar.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:31
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {axiosAPIUrl, Parameter, assignParams} from "./index";
import { AppendixFileDto } from '@/api/commonConfig'

/* 商品规格列表数据类型 */
export class RuleListDto {
    specificationId?: string;
    attrName?: string;
    attrSortNum?: number;
    specValueList?: RuleTypeDto[];
}

/* 规格列表项数据类型 */
export class RuleTypeDto {
    attrValue?: string;
    attrValueCode?: string;
    selected?: boolean;
    disabled?: boolean;
}

/* 套餐列表数据类型 */
export class PackageListDto {
    mainImageUrl?: string;
    mainImageSize?: string;
    packageId?: string;
    packageName?: string;
    packageNameDesc?: string;
    packageCode?: string;
    barcode?: string;
    weight?: string;
    /* 订货价 */
    orderPrice?: number;
    /* 市场价 */
    marketPrice?: number;
    /* 起定量 */
    minimum?: number;
    /* 限定量 */
    maximum?: number;
    isOnShelf?: boolean;
    activityPrice?:string
    skuTypes?: string[];
    goodsCount?:number
    finalPrice?:number
}

/* 选择规格的组合数据类型 */
export class SelectSKUListDto {
    ruleId?: string;
    ruleTypeId?: string;
    index?: number;
    i?: number;
}

/* 购物车列表数据类型 */
export class BuyCarListDto {
    shopId?: string;
    shopName?: string;
    shopLogo?: string;
    /* 是否已选中 */
    isChecked?: boolean;
    /* 商品套餐清单 */
    goodsPackageList?: BuyCarPackageListDto[];
}

/* 商品套餐清单列表数据类型 */
export class BuyCarPackageListDto {
    autoId?: string;
    goodsId?: string;
    packageId?: string;
    goodsName?: string;
    packageMainImage?: string;
    packageName?: string;
    packageNameDesc?: string;
    packagePrice?: string;
    orderQuantity?: number;
    /* 起定量 */
    minimum?: number;
    /* 限定量 */
    maximum?: number;
    isValid?: boolean;
    isMultiSpec?: boolean;
    /* 是否已选中 */
    isChecked?: boolean;
    /* 是否是编辑数量效果 */
    isEdit?: boolean;

    activityDiscount?:string //折扣
    activityPrice?:string //	活动价格
    activityName?:string //	活动名称
    activityEndTime?:string // 结束时间
    activityId?:string //	活动id
}

/* 获取预提交订单信息入参数据类型 */
export class GetPreOrderInfoParamsDto {
    /* 操作人所属公司 */
    customerId?: string;
    // 【待下单】店铺分组清单
    shopPackageList?: PreShopPackageListDto[];
    storeList?: Array<any>
}

export class PreShopPackageListDto {
    /* 卖方 店铺Id */
    companyId?: string;
    /* 【待下单】店铺下商品清单 */
    goodsPackageList?: PreGoodsPackageListDto[]
}

export class PreGoodsPackageListDto {
    /* 商品编号 */
    goodsId?: string;
    /* 套餐编号 */
    packageId?: string;
    /* 订购数量 */
    orderQuantity?: number;
}

/**
 * 获取商品规格列表
 * @param parameter
 */
export function getGoodsSpecificationList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<{ goodsSpecificationList?: RuleListDto[], packageList?: PackageListDto[] }>>({
        url: "/cykjenterprise/shopGoods/getGoodsSpecificationList",
        method: "get",
        params: {...parameter, ...assignParams()}
    });
}

/**
 * 获取购物车中商品列表
 * @param parameter
 */
export function getShoppingCart(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<BuyCarListDto[]>>({
        url: "/cykjenterprise/shoppingCart/getShoppingCart",
        method: "post",
        data: parameter,
    });
}

/**
 * 更新购物车
 * @param parameter
 */
export function modifyShoppingCart(parameter: Parameter = {}, showLoading = true) {
    return axiosAPIUrl<Ajax.Response<BuyCarListDto[]>>({
        url: "/cykjenterprise/shoppingCart/modifyShoppingCart",
        method: "post",
        data: parameter,
        extraParams: {
            showLoading: showLoading
        }
    });
}

/* 预提交订单信息列表数据类型 */
export class PreOrderInfoListDto {
    /* 各店铺下合计金额 */
    orderMoney?: number;
    /* 各店铺下套餐种类合计 */
    packageCateAmount?: number;
    /* 各店铺下套餐数量合计 */
    packageTotalQuantity?: number;
    /* 各店铺下信息列表 */
    orderList?: PreOrderListDto[];
}

export class PreOrderListDto {
    /* 店铺编号(公司编号) */
    shopId?: string;
    /* 店铺名称(公司名称) */
    shopName?: string;
    /* 店铺Logo(公司Logo) */
    shopLogo?: string;
    /* 金额合计 */
    orderMoney?: number;
    /* 套餐种类合计 */
    packageCateAmount?: number;
    /* 套餐数量合计 */
    packageTotalQuantity?: number;
    /* 商品套餐清单 */
    purchaseOrderDtlList?: PurchaseOrderDtlDto[];
}

export class PurchaseOrderDtlDto {
    /* 商品编号 */
    goodsId?: string;
    /* 商品名称 */
    goodsName?: string;
    /* 商品编码 */
    goodsCode?: string;
    /* 最新版本号 */
    versionId?: string;
    /* 套餐编号 */
    packageId?: string;
    /* 套餐主图 */
    packageMainImage?: string;
    orderDtlId?: string;
    /* 套餐名 中文名称组合 */
    packageNameCn?: string;
    /* 套餐 规格值编码组合 */
    packageName?: string;
    /* 套餐编码 */
    packageCode?: string;
    /* 单价 */
    salePrice?: number;
    /* 数量 */
    saleAmount?: number | string;
    /* 可退货数量 */
    returnSaleAmount?: number | string;
    returnAmount?: number | string;
    /* 单价*数量 */
    orderMoney?: number;
}

/* 提交订单入参数据类型 */
export class SubmitPurchaseOrderDto {
    /* 客户编号(公司) */
    customerId?: string;
    /* 是否是由购物车提交的订单 默认否false */
    cartFlag?: boolean;
    /* 客户等级 */
    customerLevelId?: string;
    /* 收货地址 */
    receiveAddress?: string;
    /* 收货地址明细 */
    receiveAddressDtl?: string;
    /* 收货人手机 */
    receiveMobile?: string;
    /* 收货人 */
    receiveMan?: string;
    /* 提交订单列表 */
    orderList?: SubmitOrderListDto[];
}

export class SubmitOrderListDto {
    /* 供应商编号(公司) */
    companyId?: string;
    /* 订单状态 */
    orderStatus?: number;
    /* 订单类型 */
    orderType?: number;
    /* 付款状态 */
    payStatus?: number;
    /* 期望交货日期 */
    deliveryDate?: string;
    // /* 附件路径 */
    // orderFileUrl?: string;
    // /* 附件名称 */
    // orderFileName?: string;
    // /* 附件大小 */
    // orderFileSize?: string;
    /* 订单备注 */
    orderRemark?: string;
    /* 商品列表 */
    orderDtlList?: SubmitOrderDtlDto[]
    /* 附件列表 */
    orderFileList?:AppendixFileDto[]
}

export class SubmitOrderDtlDto {
    /* 版本编号 */
    versionId?: string;
    /* 商品编号 */
    goodsId?: string;
    /* 套餐编号 */
    setmealId?: string;
    /* 数量 */
    saleAmount?: number | string;
}

/**
 * 获取预提交订单信息
 * @param parameter
 */
export function getPreOrderInfo(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<PreOrderInfoListDto>>({
        url: "/cykjorder/OM/getPreOrderInfo",
        method: "post",
        data: parameter,
    });
}

export class AddressListInfoDto {
    companyId?: string;
    addressList?: ShopAddressListDto[];
}

export class ShopAddressListDto {
    /* 收货地址(只有省市区) */
    jraddress?: string;
    /* 收货地址 */
    address?: string;
    /* 收货地址 */
    addressId?: string;
    /* 收货地址描述 */
    addressName?: string;
    /* 收货地址明细 */
    addressDtl?: string;
    /* 收货人电话 */
    receiveMobile?: string;
    /* 收货人 */
    receiveMan?: string;
    /* 是否默认收货地址 */
    isDefault?: number;
    /* 自动编号 */
    autoId?: string;
    /* 经度 */
    longitude?: number;
    /* 纬度 */
    latitude?: number;
}

/**
 * 获取公司收货地址信息
 * @param parameter
 */
export function getCompanyAddressInfo(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<AddressListInfoDto>>({
        url: "/cykjoperation/companyQuery/getCompanyAddressInfo",
        method: "post",
        data: parameter,
    });
}

/**
 * 提交订单
 * @param parameter
 */
export function submitPurchaseOrder(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjorder/OM/submitPurchaseOrder",
        method: "post",
        data: parameter,
    });
}

/* 订单提交结果列表数据类型 */
export class OrderResultListDto {
    /* 订单列表-订货单号 */
    orderId?: string;
    /* 订单列表-应付金额 */
    orderMoney?: number;
    currRouteId?: number;
}
